<template>
  <div class="page-sign-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">簽收掃描</div>
    </div>

    <div class="card-block">
      <!-- <Form inline class="pg-form-inline">
          <FormItem>
              <Select size="small" placeholder="提貨櫃點" @on-change="handleStoreChange(form.arrive)" v-model="form.arrive">
                  <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                          :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                  </Option>
              </Select>
          </FormItem>
          <FormItem>
              <Select size="small" placeholder="貨架號" v-model="form.shelves" ref="resetSelect" clearable>
                  <Option :value="item.id" v-for="(item, index) in pickShelves"
                          :key="item.id">{{item.code}}
                  </Option>
              </Select>
          </FormItem>
          <FormItem>
              <Select size="small" placeholder="付款狀況" v-model="form.pay_type" ref="resetSelect" clearable>
                  <Option value="0">未在APP內付款</Option>
                  <Option value="1">已在APP內付款</Option>
              </Select>
          </FormItem>
          <FormItem>
              <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                          placeholder="到店起始日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.start_time"></DatePicker>
          </FormItem>
          <FormItem>-</FormItem>
          <FormItem>
              <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                          placeholder="到店結束日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.end_time"></DatePicker>
          </FormItem>
      </Form> -->

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input size="small" clearable v-model="form.username" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶電話</label>
          <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table ref="table"
             size="small"
             border
             no-data-text="暫無數據"
             @on-selection-change="handleSelectionChange"
             :columns="table.column"
             :data="table.data">
        <!-- <template slot-scope="{ row, index }" slot="avatar">
            <div class="avatar-box">
                <img :src="row.avatar" alt="">
            </div>
        </template> -->
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleViewRemark(index)" v-if="account_permission == 1">備註</div>
            <div class="pg-btn style3" @click="handleIntegral(index)">積分操作</div>
            <div class="pg-btn style2" @click="handleViewWuliu(index)">物流</div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
            <span class="total-price">應收款金額：{{ sums }}</span>
            <div class="pg-btn-wrap" style="margin-left: 20px;">
              <div class="pg-btn style1" @click="handleSign">收款並簽收</div>
            </div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select v-model="curPageSize" size="small" placeholder="數量"
                        @on-change="handlePageSizeChange">
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                       @on-enter="handlePageEnter"/>
              </div>

              <Page size="small"
                    :current="pageIndex"
                    :page-size="curPageSize"
                    :total="totalCount"
                    @on-change="handlePageChange">
              </Page>
            </div>
          </Col>
        </Row>
      </div>

    </div>

    <Modal v-model="isShowModalSign"
           title="收款並簽收"
           width="650"
           :footer-hide="true"
           @on-cancel="handleModalSignClose">

      <div class="modal-cont">
        <div class="integral-info">
          <Spin fix class="pg-sub-loading" v-if="infoSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
          </Spin>
          <span>餘額積分：<span class="spanco">{{ signInfo.integral + signInfo.integralTw }}</span></span>
          <!-- <span>贈送積分：<span class="spanco">{{signInfo.integralTw}}</span></span> -->
          <span>總收金額：<span class="spanco">{{ Math.floor(signInfo.sum) }}</span></span>
          <span>是否免超期費：<span class="spanco">{{ this.signInfo.outtimepay }}</span>
                        <span class="span-left">
                            <Checkbox
                              class="span-r"
                              size="small"
                              slot="suffix"
                              v-model="checkOutTimePay"
                              @on-change="changeOutTimePay"
                            >
                            </Checkbox>
                        </span>
                    </span>
          <span v-if="this.signInfo.pay_status == 0">是否免附加費：<span
            class="spanco">{{ this.signInfo.surcharge_price }}</span>
                        <span class="span-left">
                            <Checkbox
                              class="span-r"
                              size="small"
                              slot="suffix"
                              v-model="checkAdditional"
                              @on-change="changeAdditional"
                            >
                            </Checkbox>
                        </span>
                    </span>
          <span v-if="this.signInfo.delivery == 1">
                        送貨上門費
                        <span class="span-left">
                            <Checkbox
                              class="span-r"
                              size="small"
                              slot="suffix"
                              v-model="checkOutDelivery"
                              @on-change="changeDelivery"
                            >
                            </Checkbox>
                        </span>
                    </span>
          <span>門店立減：<span class="spanco">{{ this.activity }}</span></span>
        </div>

        <Row>
          <Col span="22" pull="1">
            <Form :label-width="150">
              <FormItem v-if="checkOutDelivery">
                <div slot="label" class="form-label">
                  <span>送貨上門費</span>
                </div>
                <div>
                  <Input v-model="modalForm.delivery.value" type='number'></Input>
                </div>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>積分</span>
                </div>
                <div>
                  <Input v-model="modalForm.jifen.value" type='number' :disabled="!modalForm.jifen.isChecked">
                    <Checkbox class="input-suffix-cb"
                              size="small"
                              slot="suffix"
                              v-model="modalForm.jifen.isChecked"
                              @on-change="handleModalChecbox(arguments[0], 'jifen')"></Checkbox>
                  </Input>
                </div>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>現金</span>
                </div>
                <div>
                  <Input v-model="modalForm.cash.value" type='number' :disabled="!modalForm.cash.isChecked">
                    <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                              v-model="modalForm.cash.isChecked"
                              @on-change="handleModalChecbox(arguments[0], 'cash')"></Checkbox>
                  </Input>
                </div>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>澳門通</span>
                </div>
                <Input v-model="modalForm.aomentong.value" type='number' :disabled="!modalForm.aomentong.isChecked">
                  <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                            v-model="modalForm.aomentong.isChecked"
                            @on-change="handleModalChecbox(arguments[0], 'aomentong')"></Checkbox>
                </Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>MPay</span>
                </div>
                <Input v-model="modalForm.mPay.value" type='number' :disabled="!modalForm.mPay.isChecked">
                  <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                            v-model="modalForm.mPay.isChecked"
                            @on-change="handleModalChecbox(arguments[0], 'mPay')"></Checkbox>
                </Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>支付寶</span>
                </div>
                <Input v-model="modalForm.alipay.value" type='number' :disabled="!modalForm.alipay.isChecked">
                  <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                            v-model="modalForm.alipay.isChecked"
                            @on-change="handleModalChecbox(arguments[0], 'alipay')"></Checkbox>
                </Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>中銀POS</span>
                </div>
                <div>
                  <Input v-model="modalForm.zyPos.value" type='number' :disabled="!modalForm.zyPos.isChecked">
                    <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                              v-model="modalForm.zyPos.isChecked"
                              @on-change="handleModalChecbox(arguments[0], 'zyPos')"></Checkbox>
                  </Input>
                </div>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>工銀POS</span>
                </div>
                <Input v-model="modalForm.gyPos.value" type='number' :disabled="!modalForm.gyPos.isChecked">
                  <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                            v-model="modalForm.gyPos.isChecked"
                            @on-change="handleModalChecbox(arguments[0], 'gyPos')"></Checkbox>
                </Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>微信</span>
                </div>
                <Input v-model="modalForm.wxpay.value" type='number' :disabled="!modalForm.wxpay.isChecked">
                  <Checkbox class="input-suffix-cb" size="small" slot="suffix"
                            v-model="modalForm.wxpay.isChecked"
                            @on-change="handleModalChecbox(arguments[0], 'wxpay')"></Checkbox>
                </Input>
              </FormItem>

            </Form>
          </Col>
        </Row>

        <div class="pg-btn-wrap center">
          <div class="pg-btn style1" @click="handlePay">確定</div>
        </div>
      </div>
    </Modal>

  </div>
</template>

<script>
import Store from '../../../assets/js/store.js'

let isthis;
export default {
  data() {
    return {
      successAudio: 'music-success.mp3', //成功音效
      errorAudio: 'music-fail.mp3', //失敗音效
      pageIndex: 1, //頁碼
      curPageSize: 10, //一頁數量
      totalCount: 1, //總條數
      pageInput: '', //輸入的頁碼
      pickAddress: [], //提貨櫃點
      pickShelves: [], //貨架號
      account_permission: Store.fetch().type,
      form: {
        arrive: Store.fetch().store_id, //提貨櫃點id
        start_time: '', //起始日期
        end_time: '', //結束日期
        odd_numbers: '', //快遞單號
        phone: '', //電話號碼
        sack_number: '', //袋號
        shelves: '', //貨架號
        username: '', //用户名稱
        pay_type: ''
      },
      activity: '',
      outtimepay: '',
      pay_type: '',
      sums: 0,
      isSubmiting: false,
      infoSubmiting: false,
      checkOutTimePay: false,
      additional: '', // 附加費
      checkAdditional: false,
      checkOutDelivery: false,
      table: {
        column: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            minWidth: 230
          },
          {
            title: '上架天數',
            key: 'save_time',
            align: 'center',
            minWidth: 50,
            sortable: true
          },
          {
            title: '付款狀況',
            key: 'pay_type',
            align: 'center',
            minWidth: 130,
            sortable: true
          },
          {
            title: '客戶名稱【積分】',
            key: 'recipient_contacts',
            align: 'center',
            minWidth: 130,
            sortable: true
          },
          {
            title: '客戶電話',
            key: 'recipient_phone',
            align: 'center',
            minWidth: 130,
            sortable: true
          },
          {
            title: '出貨單號',
            key: 'odd_numbers',
            align: 'center',
            minWidth: 150,
            sortable: true
          },
          {
            title: '貨架號',
            key: 'shelves',
            align: 'center',
            minWidth: 130,
            sortable: true
          },
          {
            title: '代收費',
            key: 'amount',
            align: 'center',
            minWidth: 50,
            sortable: true,
            className: 'demo-table-info-cell-name'
          },
          {
            title: '到付運費',
            key: 'freight_collect',
            align: 'center',
            minWidth: 50,
            sortable: true,
            className: 'demo-table-info-cell-name'
          },
          {
            title: '加收附加費',
            key: 'surcharge_price',
            align: 'center',
            minWidth: 50,
            sortable: true,
            className: 'demo-table-info-cell-name'
          },
          {
            title: '超期費',
            key: 'outtimepay',
            align: 'center',
            minWidth: 50,
            sortable: true,
            className: 'demo-table-info-cell-name'
          },
          {
            title: '門店立減費',
            key: 'activity',
            align: 'center',
            minWidth: 50,
            sortable: true,
            className: 'demo-table-info-cell-name'
          },
          {
            title: '合計費用',
            key: 'sum',
            align: 'center',
            minWidth: 50,
            sortable: true,
            className: 'demo-table-info-cell-name-sum'
          },
          {
            title: '取貨櫃點',
            key: 'receivingName',
            align: 'center',
            minWidth: 150
          },
          {
            title: '袋號',
            key: 'sack_number',
            align: 'center',
            sortable: true,
            minWidth: 130
          },
          {
            title: '品名',
            key: 'productName',
            align: 'center',
            sortable: true,
            minWidth: 130,
          },
          {
            title: '到店時間',
            key: 'arrive_time',
            align: 'center',
            sortable: true,
            minWidth: 160
          },
          {
            title: '備註',
            key: 'remarks',
            align: 'center',
            sortable: true,
            minWidth: 160
          }
        ],
        data: []
      },
      isShowModalSign: false,  //收款并签收信息
      curCheckedList: [], //当前选中的数据
      signInfo: {},

      isPaying: false,
      modalForm: {
        delivery: {
          isChecked: true
        },
        jifen: {
          value: 0,
          isChecked: true
        },
        cash: {
          value: 0,
          isChecked: false
        },
        aomentong: {
          value: 0,
          isChecked: false
        },
        mPay: {
          value: 0,
          isChecked: false
        },
        zyPos: {
          value: 0,
          isChecked: false
        },
        gyPos: {
          value: 0,
          isChecked: false
        },
        alipay: {
          value: 0,
          isChecked: false
        },
        wxpay: {
          value: 0,
          isChecked: false
        },
      }
    };
  },
  created() {
    isthis = this;
    this.getPickAddress();
    this.getShelvesList();
  },
  methods: {
    handleViewRemark(index) {
      let tableData = this.table.data;
      this.$router.push({path: '/shopSignetodoRemark?id=' + tableData[index].remark_id});
    },
    formatDate(datetime) {
      if (!datetime) return '';
      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
    },
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },
    getPickAddress() //提貨櫃點
    {
      this.$Rq.requestAuth({
        url: this.$Api.pickAddress,
        method: 'get',
        data: {
          company_id: 1,
        }
      }).then((res) => {
        if (res.code == 0) {
          this.pickAddress = res.data.data;
          if (res.data.data.length <= 1) {
            this.form.arrive = res.data.data[0].ReceivingID;
          }
        }
      });
    },
    getShelvesList(list) //貨架號
    {
      if (list > 0) {
        this.$Rq.requestAuth({
          url: this.$Api.shelvesAllList,
          method: 'get',
          data: {
            store_id: list,
          }
        }).then((res) => {
          if (res.code == 0) {
            this.pickShelves = res.data;
          }
        });
      } else {
        this.$Rq.requestAuth({
          url: this.$Api.shelvesAllList,
          method: 'get',
          data: {
            store_id: Store.fetch().store_id,
          }
        }).then((res) => {
          if (res.code == 0) {
            this.pickShelves = res.data;
          }
        });
      }
    },
    arrive_time_count(date1) {
      var date1 = date1;
      var date2 = new Date();
      var date3 = date2.getTime() - new Date(date1).getTime();
      var subMinutes = Math.floor(date3 / (60 * 1000));
      var days = Math.floor(date3 / (24 * 3600 * 1000));
      var leave1 = date3 % (24 * 3600 * 1000);
      var hours = Math.floor(leave1 / (3600 * 1000));
      var leave2 = leave1 % (3600 * 1000);
      var minutes = Math.floor(leave2 / (60 * 1000));
      var leave3 = leave2 % (60 * 1000);
      var seconds = Math.round(leave3 / 1000);
      return (days)
    },
    handleStoreChange(index) {
      this.$refs.resetSelect.clearSingleSelect();
      this.getShelvesList(index);
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;
      this.$Rq.requestAuth({
        url: this.$Api.scanIn,
        method: 'get',
        data: {
          arrive: form.arrive,
          odd_numbers: form.odd_numbers,
          phone: form.phone,
          username: form.username,
          sack_number: form.sack_number,
          status: 3,
          offset: (this.pageIndex - 1) * this.curPageSize,
          limit: this.curPageSize,
        }
      }).then((res) => {
        this.isSubmiting = false;
        if (res.code == 0) {
          let tempArr = [];
          let class_temp = [];
          let class_pay_type = [];
          let resData = res.data.data;

          for (let i = 0; i < resData.length; i++) {
            let integral_tw = 0;
            if (resData[i].user != null) {
              for (let j = 0; j < resData[i].user.tw.length; j++) {
                let integral_tw_count = Number(resData[i].user.tw[j].integral);
                integral_tw += integral_tw_count;
              }
            }

            if (resData[i].pay_type == 0) {
              class_pay_type[i] = '';
            } else {
              class_pay_type[i] = 'demo-table-app-row';
            }

            if (this.arrive_time_count(resData[i].arrive_time) >= 7) {
              class_temp[i] = 'demo-table-info-row';
            } else if (this.arrive_time_count(resData[i].arrive_time) >= 2) {
              class_temp[i] = 'demo-table-error-row';
            } else {
              class_temp[i] = '';
            }

            tempArr.push({

              remark_id: resData[i].id,

              user_id: resData[i].user.user_id,

              recipient_contacts: resData[i].user == null ? resData[i].recipient_contacts : resData[i].recipient_contacts + '【' + (resData[i].user.user_integral + integral_tw) + '】', //客戶名稱【積分】

              recipient_phone: resData[i].recipient_phone, //客戶電話

              odd_numbers: resData[i].odd_numbers, //出貨單號

              shelves: resData[i].shelves == null ? '- - -' : resData[i].shelves.code, //貨架號

              pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //付款状况

              sum: Number(resData[i].amount) + Number(resData[i].freight_collect) + Number(resData[i].surcharge_price) + Number(resData[i].outtimepays || 0) - Number(resData[i].store == null ? 0 : resData[i].store.activity), //合計費用

              freight_collect: Number(resData[i].freight_collect), // 到付運費

              surcharge_price: Number(resData[i].surcharge_price), // 加收附加費

              outtimepay: resData[i].outtimepays ? resData[i].outtimepays : 0, //超期費

              amount: Number(resData[i].amount), // 代收費

              activity: resData[i].store == null ? 0 : '-' + resData[i].store.activity, // 門店立減費

              receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點

              sack_number: resData[i].sack_number, //袋號

              productName: resData[i].detailed.name, //品名

              arrive_time: resData[i].arrive_time, // 到店時間

              remarks: resData[i].remarks, //備註

              save_time: this.arrive_time_count(resData[i].arrive_time), cellClassName: { //記錄
                save_time: class_temp[i],
                pay_type: class_pay_type[i]
              }
            });
          }
          this.totalCount = res.data.count;
          this.table.data = tempArr;
        } else {
          this.showTipInfo(res.msg);
        }
      }).catch((err) => {
        this.isSubmiting = false;
      });
    },
    getSignInfo() //签收获取积分和收款金额
    {
      this.isSubmiting = true;

      let odd_numbers = this.curCheckedList.map((item, index) => {
        return item.odd_numbers;
      });
      let amount = this.curCheckedList.map((item, index) => {
        return item.amount;
      });
      let activity = this.curCheckedList.map((item, index) => {
        return item.activity;
      });
      let outtimepay = this.curCheckedList.map((item, index) => {
        return item.outtimepay;
      });
      let pay_type = this.curCheckedList.map((item, index) => {
        return item.pay_type;
      });
      this.$Rq.requestAuth({
        url: this.$Api.getSignInfo,
        method: 'post',
        data: {
          odd_numbers,
          amount
        }
      }).then((res) => {
        this.isSubmiting = false;

        if (res.code == 0) {

          for (var i = 0; i < pay_type.length; i++) {
            if (pay_type[0] != pay_type[i]) {
              this.$Modal.error({
                title: '警告',
                content: '不能混合簽收'
              });
              return;
            } else {
              var pay_type_condition = true;
            }
          }

          if (pay_type_condition == true) {
            if (res.data.pay_status === 1) {
              this.signInfo = res.data;
              this.activity = activity[0];

              var sum_activity = 0;
              for (let i = 0; i < activity.length; i++) {
                sum_activity += Math.abs(activity[i]);
              }
              this.signInfo.pay_status = res.data.pay_status;
              this.signInfo.activity = sum_activity;
              this.signInfo.sum = res.data.amount + res.data.outtimepay; //總費用 = 代收費+超期費+到附運費+立減3元
              this.signInfo.outtimepay = res.data.outtimepay || 0; //超期費
              this.signInfo.surcharge_price = res.data.surcharge_price || 0; //附加費
              this.signInfo.integralTw = res.data.integralTw || 0;
              this.signInfo.count = res.data.amount; //代收費+到附運費
              this.signInfo.delivery = res.data.delivery;
              this.signInfo.pay_status = res.data.pay_status;

              if (this.signInfo.sum > this.signInfo.integral) {
                this.modalForm.cash.value = Math.floor(this.signInfo.sum);
                this.modalForm.cash.isChecked = true;
                this.modalForm.jifen.isChecked = false;
              } else {
                this.modalForm.jifen.value = Math.floor(this.signInfo.sum);
                this.modalForm.jifen.isChecked = true;
                this.modalForm.cash.isChecked = false;
              }
              this.handleModalSignShow();
            }

            if (res.data.pay_status === 0) {
              this.signInfo = res.data;
              this.activity = activity[0];

              var sum_activity = 0;
              for (let i = 0; i < activity.length; i++) {
                sum_activity += Math.abs(activity[i]);
              }

              this.signInfo.pay_status = res.data.pay_status;
              this.signInfo.activity = sum_activity;
              this.signInfo.sum = res.data.amount + res.data.outtimepay + res.data.surcharge_price - this.signInfo.activity; //總費用 = 代收費 + 超期費 + 到附運費 + 立減3元
              this.signInfo.outtimepay = res.data.outtimepay || 0; //超期費
              this.signInfo.surcharge_price = res.data.surcharge_price || 0; //附加費
              this.signInfo.count = res.data.amount; //代收費 + 到附運費

              this.signInfo.integralTw = res.data.integralTw || 0;
              this.signInfo.delivery = res.data.delivery;
              this.signInfo.pay_status = res.data.pay_status;

              if (this.signInfo.sum > this.signInfo.integral) {
                this.modalForm.cash.value = Math.floor(this.signInfo.sum);
                this.modalForm.cash.isChecked = true;
                this.modalForm.jifen.isChecked = false;
              } else {
                this.modalForm.jifen.value = Math.floor(this.signInfo.sum);
                this.modalForm.jifen.isChecked = true;
                this.modalForm.cash.isChecked = false;
              }
              this.handleModalSignShow();
            }

          }
        }
      }).catch((err) => {
        this.isSubmiting = false;
      });
    },
    handleViewWuliu(index) {
      let tableData = this.table.data;
      this.$router.push({path: '/shopSigntodologisticsInfo?orderNo=' + tableData[index].odd_numbers});
    },
    handleIntegral(index) {
      let tableData = this.table.data;
      // console.log(tableData[index].user_id);
      this.$router.push({path: '/shopUserIntegral?id=' + tableData[index].user_id});
    },
    handleSearch() {
      this.pageIndex = 1;
      isthis.sums = 0;
      this.getList();
    },
    handleExport() {
      let token = localStorage.getItem('jyb_token');
      let form = this.form;
      let params = {
        'Authorization': token,
        status: 3,  //0待出库, 1已出库
        odd_numbers: form.odd_numbers,
        sack_number: form.sack_number,
        phone: form.phone,
        arrive: form.arrive,
        username: form.username,
        start_time: this.formatDate(form.start_time),
        end_time: this.formatDate(form.end_time)
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);
      if (form.start_time == '') {
        this.$Utils.showTipInfo("請選擇起始時間");
      } else if (form.end_time == '') {
        this.$Utils.showTipInfo("請選擇结束時間");
      } else {
        window.open(`${this.$Api.deliverExport_old}?${formatParams}`, '_blank');
      }
    },
    handleModalSignShow() //收款並簽收弹窗显示隐藏
    {
      this.isShowModalSign = true;
    },
    handleModalSignClose() {
      let modalForm = this.modalForm;
      for (let key in modalForm) {
        modalForm[key].isChecked = false;
        modalForm[key].value = '';
      }
      this.checkAdditional = false;
      this.checkOutTimePay = false;
      this.checkOutDelivery = false;
      this.isShowModalSign = false;
    },
    handleModalChecbox(value, field) {
      let modalForm = this.modalForm;

      for (let key in modalForm) {
        modalForm[key].isChecked = false;
      }

      modalForm[field].isChecked = value;
      this.modalForm = modalForm;

      for (let key in modalForm) {
        if (modalForm[key].isChecked == false) {
          modalForm[key].value = 0;
        } else {
          modalForm[key].isChecked = true;
          modalForm[key].value = this.signInfo.sum;
        }
      }
    },
    handleSign() //收款並簽收
    {
      if (!this.table.data.length) {
        this.$Utils.showTipInfo('暂時沒有數據');
        return;
      }

      this.curCheckedList = this.$refs.table.getSelection();
      if (!this.curCheckedList.length) {
        this.$Utils.showTipInfo('請先勾選數據');
        return;
      }

      this.getSignInfo();
    },
    changeAdditional() {
      let modalForm = this.modalForm;
      if (this.checkAdditional) {

        if (this.checkOutTimePay) {
          console.log('免附加费+免超时费');
          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if (this.signInfo.count - this.signInfo.activity <= 0) {
                modalForm[key].value = 0;
              } else {
                modalForm[key].value = Math.floor(this.signInfo.count - this.signInfo.activity);
                // console.log(Math.floor(this.signInfo.count));
              }
            }
          }
          if (this.signInfo.count - this.signInfo.activity <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = Math.floor(this.signInfo.count - this.signInfo.activity);
          }
        } else {
          console.log('免附加费+不免超时费');
          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if ((this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
                modalForm[key].value == 0;
              } else {
                modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity);
              }
            }
          }
          if ((this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity;
          }

        }
      } else {
        if (this.checkOutTimePay) {
          console.log('不免附加费+免超时费');
          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if ((this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity) <= 0) {
                modalForm[key].value = 0;
              } else {
                modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity);
              }
            }
          }
          if ((this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity) <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity;
          }

        } else {
          console.log('不免附加费+不免超时费');
          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if ((this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
                modalForm[key].value = 0;
              } else {
                modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity);

              }
            }
          }
          if ((this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity;
          }
        }
      }
    },
    changeOutTimePay() {
      let modalForm = this.modalForm;
      if (this.checkOutTimePay) {

        if (this.checkAdditional) {
          console.log('免超时费+免附加费');
          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if (Math.floor(this.signInfo.count - this.signInfo.activity) <= 0) {
                modalForm[key].value = 0;
              } else {
                modalForm[key].value = Math.floor(this.signInfo.count - this.signInfo.activity);
              }
            }
          }
          if (this.signInfo.count - this.signInfo.activity <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = Math.floor(this.signInfo.count - this.signInfo.activity);
          }
        } else {
          console.log('免超时费+不免附加费');
          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if ((this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity) <= 0) {
                modalForm[key].value = 0;
              } else {

                modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity);
              }
            }
          }
          if ((this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity) <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = Math.floor(this.signInfo.count + this.signInfo.surcharge_price - this.signInfo.activity);
          }

        }
      } else {
        if (this.checkAdditional) {

          console.log('不免超时费+免附加费');

          for (let key in modalForm) {
            if (modalForm[key].isChecked == false) {
              modalForm[key].value = 0;
            } else {
              if (this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity <= 0) {
                modalForm[key].value = 0;
              } else {
                modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity);
              }
            }
          }
          if ((this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
            this.signInfo.sum = 0;
          } else {
            this.signInfo.sum = this.signInfo.count + this.signInfo.outtimepay - this.signInfo.activity;
          }

        } else {

          console.log('不免超时费+不免附加费');

          if (this.signInfo.pay_status == 1) {
            for (let key in modalForm) {
              if (modalForm[key].isChecked == false) {
                modalForm[key].value = 0;
              } else {
                if ((this.signInfo.count + this.signInfo.outtimepay) <= 0) {
                  modalForm[key].value = 0;
                } else {
                  modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.outtimepay);
                }
              }
            }
            if ((this.signInfo.count + this.signInfo.outtimepay) <= 0) {
              this.signInfo.sum = 0;
            } else {
              this.signInfo.sum = this.signInfo.count + this.signInfo.outtimepay;
            }
          }

          if (this.signInfo.pay_status == 0) {

            for (let key in modalForm) {
              if (modalForm[key].isChecked == false) {
                modalForm[key].value = 0;
              } else {
                if ((this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
                  modalForm[key].value = 0;
                } else {
                  modalForm[key].value = Math.floor(this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity);
                }
              }
            }
            if ((this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity) <= 0) {
              this.signInfo.sum = 0;
            } else {
              this.signInfo.sum = this.signInfo.count + this.signInfo.surcharge_price + this.signInfo.outtimepay - this.signInfo.activity;
            }

          }
        }
      }
    },
    changeDelivery() {
      let modalForm = this.modalForm;
      if (this.checkOutDelivery) {
        this.modalForm.delivery.value = 0;
      } else {
        this.modalForm.delivery.value = 0;
      }
    },
    handlePay() { //确定付款

      this.infoSubmiting = true;
      //获取支付方式
      let modalForm = this.modalForm;
      let data = {};
      let odd_numbers = this.curCheckedList.map((item, index) => {
        return item.odd_numbers;
      });

      // 判斷金額
      if (this.signInfo.sum != (Math.floor(this.modalForm.jifen.value)
        + Math.floor(this.modalForm.cash.value)
        + Math.floor(this.modalForm.zyPos.value)
        + Math.floor(this.modalForm.mPay.value)
        + Math.floor(this.modalForm.aomentong.value)
        + Math.floor(this.modalForm.alipay.value)
        + Math.floor(this.modalForm.wxpay.value)
        + Math.floor(this.modalForm.gyPos.value))) {
        this.$Utils.showTipInfo('金額不匹配');
        return;
      }
      this.isPaying = true;
      data.odd_numbers = odd_numbers;
      if (Math.floor(this.modalForm.delivery.value) > 0) {
        data.delivery = Math.floor(this.modalForm.delivery.value);
        // console.log(data.delivery);
      }

      if (Math.floor(this.modalForm.jifen.value) > 0) {
        data.credit = Math.floor(this.modalForm.jifen.value);
        // console.log(data.credit);
      }
      if (Math.floor(this.modalForm.cash.value) > 0) {
        data.cash = Math.floor(this.modalForm.cash.value);
        // console.log(data.cash);
      }
      if (Math.floor(this.modalForm.zyPos.value) > 0) {
        data.zyPos = Math.floor(this.modalForm.zyPos.value);
        //console.log(data.zyPos);
      }
      if (Math.floor(this.modalForm.mPay.value) > 0) {
        data.mPay = Math.floor(this.modalForm.mPay.value);
        // console.log(data.mPay);
      }
      if (Math.floor(this.modalForm.aomentong.value) > 0) {
        data.aomentong = Math.floor(this.modalForm.aomentong.value);
        // console.log(data.aomentong);
      }
      if (Math.floor(this.modalForm.alipay.value) > 0) {
        data.alipay = Math.floor(this.modalForm.alipay.value);
        // console.log(data.alipay);
      }
      if (Math.floor(this.modalForm.gyPos.value) > 0) {
        data.gyPos = Math.floor(this.modalForm.gyPos.value);
        // console.log(data.gyPos);
      }
      if (Math.floor(this.modalForm.wxpay.value) > 0) {
        data.wxpay = Math.floor(this.modalForm.wxpay.value);
        // console.log(data.wxpay);
      }
      data.outmany = this.checkOutTimePay;// 是否免超时费
      data.additional_fee = this.checkAdditional;// 是否免附加费
      // console.log(data);

      this.$Rq.requestAuth({
        url: this.$Api.payByNew,
        method: 'post',
        data: data
      }).then((res) => {
        this.infoSubmiting = false;
        if (res.code === 0) {
          this.form.phone = '';
          this.$Utils.showSuccess(res.msg);
          let audio = new Audio();
          audio.src = require('@/assets/audio/' + this.successAudio);
          audio.play();
          this.isPaying = false;
          isthis.sums = 0;
          this.handleModalSignClose();
          this.getList();
        } else {
          this.$Modal.error({
            title: '警告',
            content: res.msg
          });
          let audio = new Audio();
          audio.src = require('@/assets/audio/' + this.errorAudio);
          ;
          audio.play();
          this.isPaying = false;
          isthis.sums = 0;
        }
      }).catch((err) => {
        this.infoSubmiting = false;
      });
    },
    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      isthis.sums = 0;
      this.getList();
    },
    handlePageInput() {
      let value = ('' + this.pageInput).replace(/\D/g, '');
      let pageCount = Math.floor(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      isthis.sums = 0;
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      isthis.sums = 0;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      isthis.sums = 0;
      this.getList();
    },
    handleSelectionChange() {
      let sums = 0;
      this.curCheckedList = this.$refs.table.getSelection();
      this.curCheckedList.forEach((item => {
        if (item.pay_type == '未在APP內付款') {
          sums += item.sum
        } else {
          sums += item.outtimepay
        }
      }))

      isthis.sums = Math.floor(sums)
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'ScanSign.scss';
</style>
<style>
.ivu-table td.demo-table-info-column {
  background-color: #FFEBDE;
  color: #000;
}

.ivu-table td.demo-table-info-cell-name {
  background-color: #D6E7FF;
  color: #515A6E;
}

.ivu-table td.demo-table-info-cell-name-sum {
  background-color: #FFEBDE;
  color: #000;
}

.ivu-table .demo-table-error-row {
  background-color: #fcffd6;
  color: #515A6E;
}

.ivu-table .demo-table-info-row {
  background-color: #FFEBDE;
  color: #515A6E;
}

.ivu-table .demo-table-app-row {
  background-color: #e8ffd6;
  color: #515A6E;
}
</style>